import { render, staticRenderFns } from "./Forgotten.vue?vue&type=template&id=1a2d064e&scoped=true&"
import script from "./Forgotten.vue?vue&type=script&lang=js&"
export * from "./Forgotten.vue?vue&type=script&lang=js&"
import style0 from "./Forgotten.vue?vue&type=style&index=0&id=1a2d064e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2d064e",
  null
  
)

export default component.exports